import { NgModule } from '@angular/core';
import { CartEventBuilder } from './cart-event.builder';

@NgModule({})
export class CartEventModule {
  // @ts-ignore
  constructor(cartEventBuilder: CartEventBuilder) {}
}
